import { apiSlice } from "../../app/api/apiSlice";

/**
 * The requesting trainee's remaining allowances, for the session entry screen (#112).
 *
 * Deliberately not cached across mounts: a trainee can burn practice minutes in one tab and
 * come back to this screen in another, and a stale balance is the exact thing this endpoint
 * exists to prevent. Enforcement is server-side either way — the socket refuses an exhausted
 * budget — so a wrong number here misleads rather than breaks.
 */
export const allowancesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllowances: builder.query({
      query: () => "/api/v1/allowances/",
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetAllowancesQuery } = allowancesApiSlice;
